import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';

interface GoogleMapProps {
  siteAddress: string;
  isChoosing: boolean;
  currentLoc: { lat: number; lng: number };
  setSiteAddress: Dispatch<SetStateAction<string>>;
  setIsChoosing: Dispatch<SetStateAction<boolean>>;
  setCurrentLoc: Dispatch<
    SetStateAction<{
      lat: number;
      lng: number;
    }>
  >;
  openMapHandler: () => void;
  closeMapHandler: () => void;
}

const GoogleMap = createContext<GoogleMapProps | undefined>(undefined);

export const GoogleMapProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [siteAddress, setSiteAddress] = useState('');
  const [isChoosing, setIsChoosing] = useState(false);
  const [currentLoc, setCurrentLoc] = useState({ lat: 0, lng: 0 });

  function openMapHandler() {
    setIsChoosing(true);
  }

  function closeMapHandler() {
    setIsChoosing(false);
  }

  useEffect(() => {
    if (siteAddress === '') {
      navigator.geolocation.getCurrentPosition((position) => {
        setCurrentLoc({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }
  }, [siteAddress]);

  return (
    <GoogleMap.Provider
      value={{
        siteAddress,
        setSiteAddress,
        isChoosing,
        setIsChoosing,
        currentLoc,
        setCurrentLoc,
        openMapHandler,
        closeMapHandler,
      }}
    >
      {children}
    </GoogleMap.Provider>
  );
};

export const useGoogleMap = () => {
  const context = useContext(GoogleMap);
  if (!context) {
    throw new Error('useGoogleMap must be used within a GoogleMapProvider');
  }
  return context;
};
